import { gsap } from 'gsap';

// Градиент: EC6328 → 65C5E6
const color = gsap.utils.interpolate("#4BB3F5", "#2C4992");
const colorLight = gsap.utils.interpolate("#4BB3F5", "#CBD4F2");
const colorLightSecond = gsap.utils.interpolate("#4BB3F5", "#408bcf");

const getGradientColor = (progress) => {
  return color(progress); // progress от 0 до 1
};

const getGradientColorLight = (progress) => {
  return colorLight(progress); // progress от 0 до 1
};

const getGradientColorLightSecond = (progress) => {
  return colorLightSecond(progress);
};


if (document.querySelector('[data-splitting-title]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-title]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'words',
    });
  });
}

if (document.querySelector('[data-splitting-words]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-words]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'words',
    });
  });
}

if (document.querySelector('[data-splitting-chars]')) {
  const targets = document.querySelectorAll('[data-splitting-chars]');

  targets.forEach((item) => {
    Splitting({
      target: item,
      by: 'chars',
    });

    const accentElements = item.querySelectorAll('.accent-el, .accent-bg-el');
    if (accentElements.length > 0) {
      accentElements.forEach((accent) => {
        const firstChar = accent.querySelector('.char');
        if (firstChar) {
          const charIndex = firstChar.style.getPropertyValue('--char-index');
          if (charIndex) {
            accent.style.setProperty('--accent-start', charIndex.trim());
          }
        }
      });
    }

    if (item.classList.contains('cl-gradient-js')) {
      const chars = item.querySelectorAll('.char');
      const total = chars.length - 1;

      if(item.classList.contains('light-gradient-type')) {
        gsap.set(chars, {
          color: (index) => getGradientColorLight(index / total),
        });
      } else if (item.classList.contains('light-gradient-type-second')) {
        gsap.set(chars, {
          color: (index) => getGradientColorLightSecond(index / total),
        });
      } else {
        gsap.set(chars, {
          color: (index) => getGradientColor(index / total),
        });
      }

      item.classList.add('is-init-cl-gradient-js');

      return;
    }

    const innerGradientBlocks = item.querySelectorAll('.cl-gradient-js');

    if (innerGradientBlocks.length > 0) {
      innerGradientBlocks.forEach((block) => {
        const blockChars = block.querySelectorAll('.char');
        const total = blockChars.length - 1;

        if(block.classList.contains('light-gradient-type')) {
          gsap.set(blockChars, {
            color: (index) => getGradientColorLight(index / total),
          });
        } else if (block.classList.contains('light-gradient-type-second')) {
          gsap.set(blockChars, {
            color: (index) => getGradientColorLightSecond(index / total),
          });
        } else {
          gsap.set(blockChars, {
            color: (index) => getGradientColor(index / total),
          });
        }

        block.classList.add('is-init-cl-gradient-js');
      });
    }
  });
}

/*if (document.querySelector('[data-splitting-chars]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-chars]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'chars',
    });
  });
  gsap.set(splitText.chars, {
    color: (index, target, targets) => color(index / (targets.length - 1))
  });
}*/

/*const variableFontAnimationElsArr = document.querySelectorAll('[data-variable-font-animation]');
variableFontAnimationElsArr.forEach((variableFontAnimationEl) => {
  const timeline = gsap.timeline({repeat: -1});
  const chars = variableFontAnimationEl.querySelectorAll(".char");

  // gsap.set(".one", {color: "#3498DB"});
  // gsap.set(".two", {color: "#E74C3C"});
  // gsap.set(".three", {color: "#F1C40F"});
  // gsap.set(".four", {color: "#3498DB"});
  // gsap.set(".five", {color: "#27AE60"});
  // gsap.set(".six", {color: "#E74C3C"});

  timeline.from(chars, {opacity: 0, scale: 0, ease: "sine", delay: 0.25})
      .to(".char", {
        opacity: 1,
        "--font-weight": 700,
        duration: 1.2,
        ease: "sine.inOut",
        stagger: {
          yoyo: true,
          each: 0.1,
          repeat: -1
        }
      }, 1);
})*/

